<template>
  <v-card class="elevation-0 px-0">
    <v-card-text class="px-0">
      <v-row class="mb-4 ta-center">
        <v-col>
          <div class="c-dark-blue fs-18 fw-500 mb-1">Search only providers that match your needs</div>
          <div class="c-dark-blue fs-26 fw-600 mb-2">What age ranges do you need care for?</div>
        </v-col>
      </v-row>
      <v-row class="mb-4 ta-center">
        <v-col>
          <span class="c-dark-blue fs-24 fw-500">{{ min }} - {{ max }} old</span>
        </v-col>
      </v-row>
      <v-row class="mb-3" justify-center>
        <v-col class="px-1">
          <v-range-slider :max="72" :min="0" :step="1" :tick-labels="ticks()" ticks="" v-model="range"></v-range-slider>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
    max: function() {
      return this.age(this.range[1])
    },

    min: function() {
      return this.age(this.range[0])
    }
  },

  data: function() {
    return {
      range: [this.search.min_age || 0, this.search.max_age || 12],
    }
  },

  methods: {
    age: function(months) {
      if(months == 0) {
        return "Newborn"
      } else if (months >= 72) {
        return "6 years +"
      }
      var years = Math.floor(months / 12)
      months = months % 12
      var str = []
      if(years >= 1) {
        str.push(years + " years")
      }
      if(months >= 1) {
        str.push(months + " months")
      }
      return str.join(" ")
    },

    ticks: function() {
      var ary = []
      for(var i = 0; i <= 72; i++) {
        if(i == 0) {
          ary.push("0")
        } else if(i >= 72) {
          ary.push("6+")
        } else if(i % 12 == 0) {
          ary.push((i/12) + " years")
        } else {
          ary.push('')
        }
      }
      return ary
    }
  },

  props: ['search'],

  watch: {
    range: function(newVal) {
      this.search.min_age = newVal[0]
      this.search.max_age = newVal[1]
    }
  }
}
</script>
